import { render, staticRenderFns } from "./KRadioSuggestions.vue?vue&type=template&id=4193b346&scoped=true&"
import script from "./KRadioSuggestions.vue?vue&type=script&lang=js&"
export * from "./KRadioSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./KRadioSuggestions.vue?vue&type=style&index=0&id=4193b346&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4193b346",
  null
  
)

export default component.exports